import i18next from "i18next";
import {locales} from "Constants/constants";
import getPercentileColor from "../../util/getPercentileColor";
import { getScreeningWindowDetails } from '../../../../services/screeningWindowService';
import getLatestScores from './getLatestScores';
import getPercentileRank from './getPercentileRank';

/**
 * This function calculates ARM boxes for a given student, assessments, metric, benchmark, custom benchmarks, and locale.
 * @param {object} student - The student object.
 * @param {array} assessments - An array of assessment objects.
 * @param {object} metric - The metric object.
 * @param {object} benchmark - The benchmark object.
 * @param {object} customBenchmarks - The custom benchmarks object.
 * @param {string} locale - The locale string.
 * @returns {object} An object containing ARM boxes for each screening window.
 */
export default async function getARMBoxes(student, assessments, metric, benchmark, customBenchmarks, locale) {
  const t = i18next.getFixedT(null, 'teacher_parent_report');
  const studentId = student && student.value;
  const armBoxes = {};
  const windows = ['BOY', 'MOY', 'EOY'];
  for (const window of windows) {
    const {startDate, endDate} = getScreeningWindowDetails(window);
    const assessmentsInWindow = assessments.filter(assessment => {
      const activityDate = new Date(assessment.createdAt);
      return activityDate > startDate && endDate > activityDate;
    });
    const latestScores = await getLatestScores(studentId, assessmentsInWindow);
    // search for "ARM SPANISH SCORES" to find ARM score is determined.
    const armScore = latestScores.armScore;
    const score = metric.value === 'ORF' ? latestScores.wcpm : armScore;
    const scoreDate = latestScores.createdAt;
    const {percentile, pacing} = getPercentileRank(score, metric, benchmark, customBenchmarks, locale, scoreDate);
    armBoxes[window] = {
      armScore,
      score,
      label: metric.value === 'ORF' ? 'WCPM' : 'ARM',
      metric: metric.value,
      percentile,
      color: getPercentileColor(pacing),
      pacing,
      window,
      benchmarkGrade: benchmark.grade,
      assessment: (metric.value === 'ARM' && locale === locales.EN_US) ? latestScores.armAssessment : latestScores.wcpmAssessment,
    }
  }
  return armBoxes;
}